// Canonical lead display helpers — ONE source of truth shared by the Leads list and the
// Sales Executive dashboard so the same lead always renders the same Lead No and priority.
//
// Lead No: `lead_no` (frozen B5E.1 business ID, YYGN-MMDDN) is the only displayable business
// identifier. Mongo `_id` is for routing/navigation only and must never be shown, in whole or
// in part. Records created before B5E.1 have no lead_no and display an em dash until a
// controlled migration assigns one.
export const leadNo = (lead) => (lead && lead.lead_no) || '—';

const HOT = 'bg-red-50 text-red-700 dark:bg-red-900/30';
const WARM = 'bg-amber-50 text-amber-700 dark:bg-amber-900/30';
const COLD = 'bg-blue-50 text-blue-700 dark:bg-blue-900/30';

// Canonical display only: DB keeps its legacy values (urgent/high/medium/low) untouched.
export const PRIO = {
  hot: ['Hot', HOT], high: ['Hot', HOT], urgent: ['Hot', HOT],
  warm: ['Warm', WARM], medium: ['Warm', WARM],
  cold: ['Cold', COLD], low: ['Cold', COLD],
  vip: ['VIP', 'bg-purple-50 text-purple-700'],
};

export const prioBadge = (p) => PRIO[p] || [p || '—', 'bg-slate-100 text-slate-600'];
